var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"imageModal"}},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.setImage(_vm.contents.content)}}},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"image",attrs:{"src":_vm.image}})]),(_vm.contents.content.text !== '')?_c('p',{domProps:{"innerHTML":_vm._s(_vm.contents.content.text)}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }